export default __webpack_public_path__ + "static/media/DSC_9077.637899cd.jpg";